import React from 'react'
import styled from 'styled-components'
import { colors, bp } from '../../theme'

const Wrap = styled.div`
  text-align: ${({ center }) => (center ? 'center' : 'left')};
  max-width: ${({ center }) => (center ? '46rem' : 'none')};
  margin: ${({ center }) => (center ? '0 auto 2.5rem' : '0 0 2.25rem')};
`

const Kicker = styled.div`
  color: ${colors.green};
  font-weight: 800;
  font-size: 0.82rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-bottom: 0.5rem;
`

const Title = styled.h2`
  font-size: 2.1rem;
  line-height: 1.15;
  color: ${colors.ink};
  margin: 0 0 0.6rem;

  @media (max-width: ${bp.mobile}) {
    font-size: 1.7rem;
  }
`

const Sub = styled.p`
  color: ${colors.slate};
  font-size: 1.05rem;
  line-height: 1.65;
  margin: 0;
`

const SectionHeader = ({ kicker, title, sub, center }) => (
  <Wrap center={center}>
    {kicker && <Kicker>{kicker}</Kicker>}
    <Title>{title}</Title>
    {sub && <Sub>{sub}</Sub>}
  </Wrap>
)

export default SectionHeader
